export default __webpack_public_path__ + "static/media/fondo_light.0d05598b.jpg";